export function promoDividerClick(element: HTMLElement) {
  window.scrollTo({
    behavior: "smooth",
    top:
      element.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      100,
  });
}
